const updates = [
  {
    time: '07-31 14:30',
    title: '《暗夜追踪》高清资源现已上线丝瓜视频',
    type: 'new' as const,
  },
  {
    time: '07-31 11:20',
    title: '蓝莓视频新增日韩综艺专区，多档热门节目入驻',
    type: 'update' as const,
  },
  {
    time: '07-31 09:15',
    title: '糖心视频生活频道改版升级，界面更清爽',
    type: 'update' as const,
  },
  {
    time: '07-30 21:00',
    title: '黑桃视频上线4K画质专区，多部经典影片重制上线',
    type: 'hot' as const,
  },
  {
    time: '07-30 16:45',
    title: '妖精视频潮流频道新增音乐MV专栏，每日更新',
    type: 'new' as const,
  },
  {
    time: '07-30 10:30',
    title: '桃花视频联合多家版权方推出正版纪录片专区',
    type: 'update' as const,
  },
  {
    time: '07-29 18:20',
    title: '69视频平台新增播放线路智能切换功能',
    type: 'hot' as const,
  },
  {
    time: '07-29 12:00',
    title: '热门动漫《星辰变》第二季全集已在多个站点同步',
    type: 'new' as const,
  },
  {
    time: '07-28 20:30',
    title: '《欢乐喜剧人》第十季本周热度突破新高',
    type: 'hot' as const,
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            实时追踪特色视频平台最新动态
          </p>
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
            <div className="space-y-5">
              {updates.map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div
                    className={`relative z-10 flex-shrink-0 w-[38px] h-[38px] flex items-center justify-center rounded-full border-2 border-background-50 ${
                      item.type === 'new'
                        ? 'bg-primary-500 text-white'
                        : item.type === 'hot'
                        ? 'bg-accent-500 text-white'
                        : 'bg-secondary-500 text-white'
                    }`}
                  >
                    <i
                      className={`${
                        item.type === 'new'
                          ? 'ri-sparkling-line'
                          : item.type === 'hot'
                          ? 'ri-fire-line'
                          : 'ri-refresh-line'
                      } text-sm`}
                    ></i>
                  </div>
                  <div className="flex-1 bg-background-50 rounded-xl p-4 border border-background-200 hover:border-primary-200 transition-all cursor-pointer">
                    <span className="text-xs text-foreground-400 mb-1 block">{item.time}</span>
                    <p className="text-sm text-foreground-800 font-medium leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}